import React from "react";
import "./App.css";
import ChatWidget from "./components/pages/mainPage";
import AnalyticsDashboard from "./components/pages/AnalyticsDashboard";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/auth/Login";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import ShadowHeading from "./components/pages/ShadowHeading";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/shadowboard" element={<ShadowHeading />} />
        {/* <Route path="/dashboard" element={<AnalyticsDashboard />} /> */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AnalyticsDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Login />} />
        <Route path="/chatwidget" element={<ChatWidget />} />
      </Routes>
    </Router>
  );
}

export default App;
